import { Button, UIText2 } from '@cian/ui-kit';
import cn from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';
import { NBSP } from 'shared/constants/common';
import { ContainerInner } from '../../../components/ContainerInner';
import { selectCalculatorErrors, selectIsOffersExist, selectMasterButton } from '../../../selectors/landing';
import { ScrollUpButtonContainer } from '../ScrollUpButtonContainer';
import { useFillApplicationButtonClick } from './hooks/useFillApplicationButtonClick';
import { EFillApplicationStickyButtonType } from './types';

import * as styles from './styles.css';

export interface IFillApplicationButtonMobileProps {
  handleOnload: (node: HTMLElement | null) => void;
}

export const FillApplicationButtonMobile: React.FC<IFillApplicationButtonMobileProps> = ({ handleOnload }) => {
  const isOffersExist = useSelector(selectIsOffersExist);
  const calculatorErrors = useSelector(selectCalculatorErrors);
  const enabledButton = useSelector(selectMasterButton);
  const handleClick = useFillApplicationButtonClick(EFillApplicationStickyButtonType.TOP);

  if (!isOffersExist || calculatorErrors.length > 0) {
    return null;
  }

  return (
    <div
      className={cn(styles['mobile-btn'], enabledButton === EFillApplicationStickyButtonType.TOP && styles['active'])}
      ref={handleOnload}
    >
      <div className={styles['scroll-up']}>
        <ScrollUpButtonContainer />
      </div>
      <ContainerInner>
        <div className={styles['mobile-wrapper']}>
          <Button fullWidth size="M" onClick={handleClick}>
            Заполнить заявку на Циане
          </Button>
          <div>
            <UIText2 textAlign="center" color="text-secondary-default">
              Заявка{NBSP}— единая для всех банков.
            </UIText2>
            <UIText2 textAlign="center" color="text-secondary-default">
              Перед заполнением попросим авторизоваться.
            </UIText2>
          </div>
        </div>
      </ContainerInner>
    </div>
  );
};
